module.exports = __webpack_public_path__ + "img/el-meridiano.fff6d408.png";